import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {DLPageTypeEnum} from '../../../../../../enums/DataLayerEnums';
import {GtmEventEnum} from '../../../../../../enums/GoogleEnums';
import {EventActionEnum, EventCategoryEnum} from '../../../../../../enums/GaTrackingEnums';
import {GtmService} from '../../../../../../services/gtm.service';
import {SearchWidgetManagerService} from '../../../../../../services/search-widget/search-widget-manager.service';
import {SearchService} from '../../../../../../services/search/search.service';
import {WindowSizeService} from '../../../../../../services/window-size.service';

@Component({
  selector: 'app-search-content-search',
  templateUrl: './search-content-search.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex flex-col gap-4 rounded-lg border border-grey-9 bg-grey-10 px-4 py-5 lg:p-0 lg:border-0 lg:bg-transparent',
  },
})
export class SearchContentSearchComponent {
  public title = input<string>(null);
  public pageType = input<DLPageTypeEnum>(null);
  public content = computed<string>(() => {
    if (this.title() && this.pageType()) {
      if (this.pageType() === DLPageTypeEnum.CARE_SERVICE_TYPE_PAGE) {
        return `Vill du hitta en mottagning som erbjuder <b>${this.title()}</b>?`;
      } else {
        return `Vill du hitta en mottagning som kan hjälpa dig med <b>${this.title()}</b>?`;
      }
    }
  });
  private windowSize = inject(WindowSizeService);
  private size = this.windowSize.windowSize;
  private readonly mobileTabsThreshold = 992;
  protected isMobile = computed<boolean>(() => this.size()[0] < this.mobileTabsThreshold);

  constructor(
    private gtmService: GtmService,
    private searchService: SearchService,
    private searchWidgetManagerService: SearchWidgetManagerService,
  ) {}

  protected expandMobileWidgetWithPlaceFocused($event): void {
    if (this.isMobile()) {
      this.searchService.isMobileWidgetExpanded.set(true);
    }

    const gtmTag = {
      event: GtmEventEnum.DEFAULT,
      Category: EventCategoryEnum.SEARCHNAV,
      Action: EventActionEnum.CHOOSE_LOCATION_BUTTON_CLICK,
      Label: 'click',
      Value: 1,
    };
    this.gtmService.pushTag(gtmTag);

    this.searchWidgetManagerService.setFocusOnPlacesField();
    this.searchWidgetManagerService.loadPlaces();
    $event.stopPropagation();
  }
}
